import { gql } from '@apollo/client';

export const SET_OPENAI_KEY = gql`
    mutation SetOpenAIKey($data: SetOpenAIKeyInput!) {
        setOpenAIKey(data: $data) {
            __typename
            ... on SetOpenAIKeySuccess {
                success
                status
            }
            ... on OpenAIKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
